<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 17:13:41
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-08-29 20:35:04
 * @FilePath: /lobby/src/components/Empty.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div>
    <div class="skeleton">
      <img v-if="showicon" :src="`${resBaseUrl}no.png`" width="55" height="60" />
      <p v-if="showicon">{{ $t('no.desc') }}</p>
      <p
        v-if="!hideRecommend"
        style="font-weight: 700; font-size: 0.3rem !important; margin-bottom: 0.5rem"
      >
        {{ $t('no.tips') }}
      </p>
      <div v-if="!hideRecommend" class="game-content">
        <div class="game" v-if="games.length > 0">
          <div class="game-group" v-for="(row, index) in this.games" :key="index">
            <GameCard
              style="width: 33%"
              v-for="(game, rowIndex) in row"
              :key="rowIndex"
              :game="game"
              :isBig="false"
              height="2.53"
            />
          </div>
        </div>
      </div>

      <!-- <img :src="`${resBaseUrl}network.png`" width="32" height="32" />
      <p>
        Travel due to network<br />
        The game failed to load. Please reload.
      </p>
      <div class="btn" @click="callback">Reload</div> -->
      <!-- <div v-if="hotitem.style == 'grid' && hotitem.rows >= 2">
        <DhGridListGames :showTitle="false" :funTab="hotitem" class="content" />
        <div class="index_banner" v-if="hotitem.haveDownBanner">
          <DhLazyBanner :name="hotitem.name" />
        </div>
      </div>
      <div v-if="hotitem.style == 'list'">
        <DhListGames :showTitle="false" :funTab="hotitem" class="content" />
        <div class="index_banner" v-if="hotitem.haveDownBanner">
          <DhLazyBanner :name="hotitem.name" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { config } from '@/common/config'
import { useLobbyStore } from '@/stores/lobby'
import { chunkArray } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import GameCard from '@/components/GameCard.vue'
export default {
  name: 'DhReload',
  components: { GameCard },
  computed: {
    ...mapState(useLobbyStore, ['categories', 'hotGame'])
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      games: []
    }
  },
  props: {
    callback: {
      type: Function,
      default: () => {
        console.log('callback')
      }
    },
    showicon: {
      type: Boolean,
      default: true
    },
    hideRecommend: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.hotGame) {
      this.getGameList(this.hotGame.id, '', 1, 3 * this.hotGame.rows)
        .then((response) => {
          this.games = chunkArray(response.games, 3, true)
        })
        .catch(() => {
          this.games = []
        })
    }
  },

  methods: {
    ...mapActions(useLobbyStore, { getGameList: 'getGameList' })
  }
}
</script>
<style lang="scss" scoped>
.skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 100%;
  height: auto;
  overflow: hidden;

  .game-content {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    flex-direction: column;
    //margin-bottom: 0.5rem;

    .game {
      display: flex;
      flex-direction: column;

      .game-group {
        display: flex;
        flex-direction: row;
        margin-left: -0.05rem;
        width: 100%;
        height: auto;
      }
    }
  }

  img {
    width: 55px;
    height: auto;
    margin-bottom: 0.3rem;
  }

  p {
    font-size: 0.24rem;
    // display: inline-block;
    line-height: 0.15rem;
    color: #ffddac;
  }

  .btn {
    width: 3.2rem;
    line-height: 0.66rem;
    text-align: center;
    border-radius: 0.33rem;
    margin: 0.4rem 0;
    color: #fff;
    background-color: #aa884a;
    border: 2px solid #aa884a;
    margin: 0.2rem auto !important;
    font-size: 0.24rem !important;
    display: inline-block;
    color: #ffddac;
  }
}
</style>
